<template>
  <div>
    <v-layout column v-if="app">
      <v-card flat>
        <!-- <v-btn icon class="ma-2" to="/marketplace">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>-->
        <v-card-text>
          <v-layout justify-space-between row fill-height>
            <v-btn icon class="ma-2" to="/marketplace">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>

            <div class="text-center">
              <h1 class="headline font-weight-regular">{{ app.name }}</h1>
              <h4 class="subheading">{{ app.description }}</h4>
              <h4 class="title font-weight-medium">
                {{ app.price | currency }}
              </h4>
            </div>
            <div></div>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-divider></v-divider>

      <v-container fluid>
        <div v-html="app.html"></div>
        <v-layout column class="my-2">
          <AppLocations
            class="mt-2"
            :app="app"
            :id="this.app.id"
          ></AppLocations>
        </v-layout>
      </v-container>
    </v-layout>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("labels.pleaseStandBy") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import marketplaceService from "../service.js";
import AppLocations from "../components/AppLocations";

export default {
  name: "marketplace-view-app",
  created() {
    this.loadApp();
  },
  components: {
    AppLocations,
  },
  data() {
    return {
      app: null,
      isLoading: true,
    };
  },
  methods: {
    loadApp() {
      if (!this.$route.params || !this.$route.params.id) {
        return this.$router.push("/");
      }

      const { id } = this.$route.params;
      this.$Progress.start();

      const currentBrand = this.$store.getters["brand/currentBrand"];
      console.log("currentBrand", currentBrand);

      marketplaceService
        .getById(id)
        .then((response) => {
          this.$Progress.finish();

          const app = response.data;

          // Brand check
          if (!app.brands || !app.brands.includes(currentBrand)) {
            this.$swal({
              icon: "error",
              title: "Not Available",
              text: "This integration is not available for your brand.",
            });
            return this.$router.push("/marketplace");
          }

          this.app = app;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$router.go(-1);
        });
    },
  },
};
</script>
